import { Injector, Type } from "@angular/core";

export abstract class TrayContainer {
    public abstract attachMapOverlay(
        componentType: Type<unknown>,
        options?: { injector?: Injector },
    ): void;

    public abstract destroyMapOverlay(): void;
}
